import React from 'react';
import { Link } from 'react-router-dom';
import ImageCarousel from '../components/ImageCarousel';
import heroCarouselData from '../data/heroCarousel.json';
import image0 from '../assets/imagecarousel/kuva0.jpg';
import image1 from '../assets/imagecarousel/kuva1.jpg';
import image2 from '../assets/imagecarousel/kuva2.jpg';
import '../App.scss';

const services = [
  {
    title: 'Yrityskuvaus 2.6',
    description: 'Premium-sessio hallitulla valolla, tekniikalla ja nopeasti julkaistavilla materiaaleilla.',
    meta: 'Studio · On location',
  },
  {
    title: 'Muotokuvat & CV-kuvat',
    description: 'Luodaan henkilöbrändisi uudelle tasolle 15 minuutissa tai kokonaisen kuvauspäivän aikana.',
    meta: 'Same-day delivery',
  },
  {
    title: 'Tapahtumat & tarinat',
    description: 'Monikamerainen dokumentointi, joka näyttää yrityksesi kulttuurin ja tunnelman.',
    meta: 'Photo + Video',
  },
];

const heroStats = [
  { label: 'Vuotta alalla', value: '24' },
  { label: 'Tehtyä keikkaa', value: '1.2k+' },
  { label: 'Toimitusaika', value: '<48h' },
];

const imageLookup = {
  kuva0: image0,
  kuva1: image1,
  kuva2: image2,
};

const heroImages = heroCarouselData.map((image) => ({
  ...image,
  src: imageLookup[image.assetKey],
}));

const Home = () => {

  return (
    <>
      <section className="home page-section">
        <span className="section-label">Lennart Takanen Photography</span>
        <div className="hero-grid">
          <div className="hero-content">
            <div className="brand-pill">Y-tunnus 13467743-1 · Helsinki</div>
            <h1>Luo visuaalisia tarinoita, jotka tuntuvat tulevaisuudelta.</h1>
            <p>
              Päivitän yrityksesi visuaaliset rajapinnat — hallitut muotokuvat, tapahtumadokumentointi ja
              graafinen suunnittelu samasta luotettavasta lähteestä. Tuloksena on rohkea ja ajaton jälki, joka
              toimii kampanjoissa, verkkosivuilla ja fyysisissä julkaisuissa.
            </p>
            <div className="hero-buttons">
              <Link to="/contact" className="btn btn-primary">Varaa suunnittelusessio</Link>
              <Link to="/portfolio" className="btn btn-secondary">Katso portfolio</Link>
            </div>
            <div className="hero-meta">
              {heroStats.map((stat) => (
                <div key={stat.label} className="hero-card">
                  <h3>{stat.value}</h3>
                  <span>{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="hero-visual">
            <div className="carousel-container">
              <ImageCarousel images={heroImages} />
            </div>
          </div>
        </div>
      </section>

      <section className="page-section">
        <span className="section-label">Palvelut</span>
        <h2 className="section-heading">Kokonaisvaltaiset kuvausratkaisut yhdellä kontaktilla</h2>
        <p className="section-subtitle">
          Moderni workflow automatisoi kulun varauksesta luovaan konseptiin, kuvauspäivään ja valmiisiin tuotoksiin.
          Jokainen paketti sisältää suunnittelun, kuvauksen ja jälkikäsittelyn.
        </p>
        <div className="service-grid">
          {services.map((service) => (
            <article key={service.title} className="service-card">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <small>{service.meta}</small>
            </article>
          ))}
        </div>
      </section>
    </>
  );
};

export default Home;
